import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../hooks/useMetaPixel';
interface CTAButtonProps {
  text: string;
  href: string;
  className?: string;
}
export function CTAButton({
  text,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Cero Inflamación en 72H',
      content_type: 'product',
      value: 15000,
      currency: 'COP'
    });
  };
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`inline-block px-8 py-4 md:px-12 md:py-5 text-white font-bold text-lg md:text-xl uppercase tracking-wider rounded-full shadow-lg cursor-pointer text-center ${className}`} style={{
    background: 'linear-gradient(135deg, #C9A96E 0%, #B8944F 100%)'
  }} whileHover={{
    scale: 1.05,
    boxShadow: '0 20px 40px rgba(201, 169, 110, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 17
  }} data-id="element-1">
      {text}
    </motion.a>;
}